import { axiosInstance } from "./axios";
import { IUser } from "dto/IUser";
import { IWorkspaceCompany } from "dto/IWorkspace";
import { IError } from "dto/IError";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";
import { IUIPrivileges } from "dto/IUIPrivileges";

const queryKeys = {
  getMe: (token: string) => ["userService.getMe", token],
  getPrivileges: () => ["userService.getPrivileges"],
};

const getMe = (): Promise<{ data: IUser }> => {
  return axiosInstance.get("/account");
};

const useGetMe = (token: string) => {
  return useCustomQuery(queryKeys.getMe(token), () => getMe(), {
    enabled: false,
    cacheTime: 0,
    staleTime: 0,
  });
};

const getPrivileges = (): Promise<{ data: IUIPrivileges }> => {
  return axiosInstance.get("/ui/privileges");
};

const useGetPrivileges = () => {
  return useCustomMutation(getPrivileges);
};

export interface IUpdateCompany {
  Name: string;
  Address: string;
  City: string;
  ZipCode: string;
  Phone: string;
  Email: string;
  NIP: string;
  REGON: string;
}

const getCompany = (): Promise<{ data: IWorkspaceCompany }> => {
  return axiosInstance.get("/account/company");
};

const useGetCompany = () => {
  return useCustomQuery("account.getCompany", () => getCompany());
};

const updateCompany = (payload: IUpdateCompany): Promise<{ data: IError }> => {
  return axiosInstance.post("/account/company", payload);
};

const useUpdateCompany = () => {
  return useCustomMutation(updateCompany);
};

const removeAccount = (): Promise<{}> => {
  return axiosInstance.get("/account/remove");
};

const useRemoveAccount = () => {
  return useCustomMutation(removeAccount);
};

const removeAccountConfirm = (data: {
  userId: string;
  token: string;
}): Promise<{}> => {
  return axiosInstance.get(`/account/confirm/${data.userId}/${data.token}`);
};

const useRemoveAccountConfirm = () => {
  return useCustomMutation(removeAccountConfirm);
};

export default {
  useGetMe,
  useUpdateCompany,
  useGetCompany,
  useGetPrivileges,
  useRemoveAccount,
  useRemoveAccountConfirm,
};
